import React from 'react';

type IconProps = {
  size?: number;
  className?: string;
};

const wrap = (size: number, className: string | undefined, children: React.ReactNode) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const IconArrowUpRight = ({ size = 18, className }: IconProps) =>
  wrap(size, className, (
    <>
      <path d="M7 17L17 7" />
      <path d="M8 7h9v9" />
    </>
  ));

export const IconArrowRight = ({ size = 18, className }: IconProps) =>
  wrap(size, className, (
    <>
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </>
  ));

export const IconArrowDown = ({ size = 18, className }: IconProps) =>
  wrap(size, className, (
    <>
      <path d="M12 5v14" />
      <path d="M6 13l6 6 6-6" />
    </>
  ));

export const IconMenu = ({ size = 22, className }: IconProps) =>
  wrap(size, className, (
    <>
      <path d="M4 7h16" />
      <path d="M4 12h16" />
      <path d="M4 17h10" />
    </>
  ));

export const IconClose = ({ size = 22, className }: IconProps) =>
  wrap(size, className, (
    <>
      <path d="M6 6l12 12" />
      <path d="M18 6L6 18" />
    </>
  ));

export const IconMail = ({ size = 18, className }: IconProps) =>
  wrap(size, className, (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="1.5" />
      <path d="M4 7l8 6 8-6" />
    </>
  ));

export const IconPin = ({ size = 18, className }: IconProps) =>
  wrap(size, className, (
    <>
      <path d="M12 21s7-5.4 7-11a7 7 0 10-14 0c0 5.6 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.2" />
    </>
  ));

export const IconGithub = ({ size = 18, className }: IconProps) =>
  wrap(size, className, (
    <path d="M9 19c-4.3 1.4-4.3-2.5-6-3m12 5v-3.9a3.4 3.4 0 00-.9-2.6c3-.3 6.1-1.5 6.1-6.6a5 5 0 00-1.4-3.5 4.7 4.7 0 00-.1-3.5S17.3 2 15 3.6a12 12 0 00-6 0C6.7 2 5.4 1.9 5.4 1.9a4.7 4.7 0 00-.1 3.5A5 5 0 003.9 8.9c0 5.1 3.2 6.3 6.1 6.6a3.4 3.4 0 00-.9 2.6V21" />
  ));

export const IconLinkedin = ({ size = 18, className }: IconProps) =>
  wrap(size, className, (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="2" />
      <path d="M8 10.5V16.5" />
      <path d="M8 7.5h.01" />
      <path d="M12 16.5v-3.2a2 2 0 012.3-2c1.4.1 1.7 1.1 1.7 2.5v2.7" />
    </>
  ));

export const IconPlayStore = ({ size = 18, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M3.6 2.7c-.3.2-.6.6-.6 1.1v16.4c0 .5.3.9.6 1.1l10.1-9.3L3.6 2.7zm12.1 8.4l-2.3 2.1 2.9 2.9 3.4-1.9c.8-.5.8-1.6 0-2.1l-4-2.3-2.9 1.3 2.9 0zM13.1 14.6l-2.3-2.3-6.6 6.1 8.9-3.8zm0-5.2L4.2 5.6l6.6 6.1 2.3-2.3z" />
  </svg>
);

export const IconAppStore = ({ size = 18, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M16.2 12.9c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.2-2.8.9-3.5.9s-1.9-.8-3.1-.8c-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.1 1.2 9.4.8 1.1 1.7 2.4 3 2.4 1.2 0 1.6-.8 3.1-.8s1.8.8 3.1.8c1.3 0 2.1-1.2 2.9-2.3.5-.8 1-1.7 1.3-2.7-1.6-.6-2.7-2.2-2.7-4zM14.3 6.7c.7-.8 1.1-1.9.9-3-1 .1-2 .6-2.6 1.4-.6.7-1.1 1.8-.9 2.8 1 .1 2-.5 2.6-1.2z" />
  </svg>
);
